import { Component} from '@angular/core';
import { ModalController } from '@ionic/angular';

export interface HotkeyItem{
  description: string,
  subDescription?: string,
  keysMac: string[],
  keysWin: string[],
}

@Component({
    selector: 'app-hotkeys',
    templateUrl: './hotkeys.component.html',
    styleUrls: ['./hotkeys.component.scss'],
    standalone: false
})
export class HotkeysComponent {


  public globalHotkeys: HotkeyItem[] = [
    {description: "Schnell-Suche öffnen", keysMac: ["⌘", "P"], keysWin: ["Strg", "P"]}
  ]

  public ticketOverviewHotkeys: HotkeyItem[] = [
    {description: "Ticket in neuem Tab öffnen", keysMac: ["⌘", "*klick*"], keysWin: ["Strg", "*klick"]},
  ]

  public ticketDetailHotkeys: HotkeyItem[] = [
    {description: "Neue Nachricht", keysMac: ["⌘", "M"], keysWin: ["Strg", "M"]},
    {description: "Text speichern", subDescription: "Nur wenn Geräte eine Nachrichte erstellt oder bearbeitet wird.", keysMac: ["⌘", "Enter"], keysWin: ["Strg", "Enter"]},
    {description: "Text speichern", subDescription: "Nur wenn Geräte eine Nachrichte erstellt oder bearbeitet wird.", keysMac: ["⌘", "S"], keysWin: ["Strg", "S"]},
    {description: "Tätigkeit ohne Zeit", subDescription: "Erstellt eine Tätigkeit ohne die Zeit zu starten. (Wenn man sich in Textbox befinden)", keysMac: ["⌘", "Enter"], keysWin: ["Strg", "Enter"]},
  ]

  public boards: HotkeyItem[] = [
    {description: "Suche öffnen", keysMac: ["⌘", "F"], keysWin: ["Strg", "F"]},
    {description: "Ticket in neuem Tab öffnen", keysMac: ["⌘", "*klick*"], keysWin: ["Strg", "*klick"]},
  ]

  public ticketTime: HotkeyItem[] = [
    {description: "Ticket öffnen", keysMac: ["⌘", "O"], keysWin: ["Strg", "O"]},
    {description: "Ticket öffnen", keysMac: ["⌘", "*klick*"], keysWin: ["Strg", "*klick"]},
    {description: "Zeit löschen", keysMac: ["⌘", "Backspace"], keysWin: ["Entfernen"]},
    {description: "Zeit stoppen", subDescription: "Nur wenn die ausgewählte Zeit eine laufende Zeit ist.", keysMac: ["⌘", "S"], keysWin: ["Strg", "S"]},
    {description: "Zeit kopieren", subDescription: "Kopiert die ausgewählte Zeit.", keysMac: ["⌘", "C"], keysWin: ["Strg", "C"]},
    {description: "Zeit einfügen", subDescription: "Fügt eine kopierte Zeit ein.", keysMac: ["⌘", "V"], keysWin: ["Strg", "V"]},
  ]

  constructor(
    private modalCtrl: ModalController
  ) { 
    
  }

  public async close(){
    await this.modalCtrl.dismiss()
  }

}
